import ProximityAd from 'components/Ad/ProximityAd';
import { screen } from 'components/styles/variables';
import { TINY_RECTANGLE_2 } from 'lib/GoogleAds/Sizes';
import css from 'styled-jsx/css';
import classNames from 'classnames';

/* istanbul ignore next */
const { styles, className } = css.resolve`
  .sidebar-ad {
    margin-bottom: 20px;
  }
`;
const stickyCss = css.resolve`
  position: sticky;
  top: 0;
`;

export interface SidebarAdsProps {
  sticky?: boolean;
  sellerId?: string;
}

export default function SidebarAds({ sticky = true, sellerId }: SidebarAdsProps): JSX.Element {
  return (
    <div className="sidebar-ads">
      <ProximityAd
        adConfig={{
          targeting: { inLine: 2, sellerId },
          dimensions: [
            [300, 250],
            [300, 600],
          ],
        }}
        placeholderSize={TINY_RECTANGLE_2}
        className={`sidebar-ad ${className}`}
      />
      <ProximityAd
        placeholderSize={TINY_RECTANGLE_2}
        adConfig={{
          targeting: { inLine: 3, sellerId },
          dimensions: [[300, 250]],
        }}
        className={`sidebar-ad ${className}`}
      />
      <ProximityAd
        className={classNames({
          [stickyCss.className]: sticky,
        })}
        placeholderSize={TINY_RECTANGLE_2}
        adConfig={{
          targeting: { inLine: 4, sellerId },
          dimensions: [
            [300, 250],
            [300, 600],
          ],
        }}
      />
      <style jsx>{`
        .sidebar-ads {
          display: none;
        }

        @media (min-width: ${screen.lgMin}) {
          .sidebar-ads {
            display: block;
            width: 300px;
            flex-shrink: 0;
          }
        }
      `}</style>
      {styles}
      {stickyCss.styles}
    </div>
  );
}
